import ky from 'ky';
import Config from '../../config';

export interface CreditsPageData {
    id: number;
    title: string;
}

export interface CreditsPageDetailData extends CreditsPageData {
    content: string;
    lastupdate: number;
}

export interface CreditsIndexData {
    name: string;
    pages: CreditsPageData[];
}

export interface CreditsMenuData {
    title: string;
    link: string;
}

class CreditsUtils {
    private pathname: string;
    private index?: CreditsIndexData | null;

    constructor(path: string) {
        this.pathname = path;
    }

    getIndexUrl(): string {
        return `${this.pathname}/`;
    }

    getPageUrl(id: number): string {
        return this.getIndexUrl() + (0 === id ? 'aboutus.php' : `?id=${id}`);
    }

    async getIndex(): Promise<CreditsIndexData | null> {
        if (typeof this.index === 'undefined') {
            try {
                const url = `${this.getIndexUrl()}index.json`;
                const index = await ky
                    .get(new URL(Config.BASE_URL + url, window.location.href))
                    .json<CreditsIndexData>();
                this.index = index;
            } catch (_err) {
                this.index = null;
            }
        }
        return this.index;
    }

    async getMenu(): Promise<CreditsMenuData[]> {
        const menu: CreditsMenuData[] = [];
        const index = await this.getIndex();
        if (index !== null) {
            index.pages.forEach((page) => {
                menu.push({ title: page.title, link: this.getPageUrl(page.id) });
            });
        }
        return menu;
    }

    async getPage(id: number): Promise<CreditsPageDetailData | null> {
        let page = null;
        try {
            const url = `${this.getIndexUrl() + id}.json`;
            page = await ky.get(new URL(Config.BASE_URL + url, window.location.href)).json<CreditsPageDetailData>();
        } catch (_err) {
            // ignore
        }
        return page;
    }
}

export default new CreditsUtils('/modules/credits');
